import { Component, OnInit, SimpleChanges, Input, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'
// import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import { saveAs } from "file-saver";
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-evidence-reference',
  templateUrl: './evidence-reference.component.html',
  styleUrls: ['./evidence-reference.component.scss']
})
export class EvidenceReferenceComponent implements OnInit {

  @Input('learner') learnerData;
  @Input('job') singleJob;
  @Input('assessment') evidencerefercnceEdit;
  @Input('list') evidenceList

  criteriaType = [{ key: 'Not Met', value: 'notMet' }, { key: 'Part Met', value: 'partMet' }, { key: 'Met', value: 'met' }]
  currentJob
  eviReferenceForm
  selectedLearner
  job
  // evidenceList = []
  learnerId
  currentLearner
  jobId
  loading
  evidenceFormEdit
  user: any;
  isLearner: boolean = false;
  isDisplay: boolean = false
  private evidenceSubscription: Subject<any> = new Subject<any>();
  private deleteEvidenceSubscription: Subject<any> = new Subject<any>();
  // assessmentEdit
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public cd: ChangeDetectorRef

  ) {

    this._learnerService.newEvidenceObservable().subscribe((newEvidence) => {
      console.log("new Evidence Here ====>", newEvidence)
      let data1 = newEvidence.data
      this.evidenceList.push(data1)
    })

    this._learnerService.removeEvidenceObservable()
      .pipe(
        takeUntil(this.deleteEvidenceSubscription)
      )
      .subscribe((removeEvidence) => {
        console.log("new remove Evidence ====>", removeEvidence)


        let index = this.evidenceList.findIndex(x => x._id === removeEvidence._id);
        if (index > -1) {
          this.evidenceList.splice(index, 1)
          console.log("after learner remove in assignment page", this.evidenceList);
        }
        if (this.evidenceFormEdit) {
          this.isDisplay = true
          this.createForm(this.evidenceFormEdit)
          this.submitEvirefernce()
        }
      })


    this._learnerService.editEvidenceObservable()
      .pipe(
        takeUntil(this.evidenceSubscription)
      )
      .subscribe((editEvidence) => {
        console.log("Here is Edit Evidence Observable===>", editEvidence)
        let data1 = editEvidence[0]
        let index = this.evidenceList.findIndex(x => x._id === editEvidence[0]._id);
        if (index > -1) {
          this.evidenceList.splice(index, 1, data1)
          console.log("after learner remove in assignment page", this.evidenceList);
        }

        if (this.evidenceFormEdit) {
          this.isDisplay = true
          this.createForm(this.evidenceFormEdit)
          this.submitEvirefernce()
        }

      })


  }

  ngOnDestroy() {
    this.evidenceSubscription.next();
    this.evidenceSubscription.complete();
    this.deleteEvidenceSubscription.next();
    this.deleteEvidenceSubscription.complete();
  }




  // editEvidenceObservable

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("userRole Check:", this.user)
    if (this.user && this.user.isLearner) {
      this.isLearner = this.user.isLearner

    }
    // this.createForm()
  }


  //ngOnchanges

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.learnerData && changes.learnerData.currentValue) {
      // this.singleLearner = changes.learnerData.currentValue
      this.learnerId = changes.learnerData.currentValue._id
      this.currentLearner = changes.learnerData.currentValue
    }

    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobId = changes.singleJob.currentValue[0]._id
      this.job = changes.singleJob.currentValue[0]
      console.log("changes in evidence Reference....JOB", changes.singleJob.currentValue);

    }


    // if (this.learnerId && this.jobId) {
    //   this.getEvidenceList()
    // }

    if (changes.evidencerefercnceEdit && changes.evidencerefercnceEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.evidencerefercnceEdit.currentValue)
      this.evidenceFormEdit = changes.evidencerefercnceEdit.currentValue
      console.log("assement plan edit data", this.evidenceFormEdit);

      if (this.evidenceFormEdit && this.evidenceFormEdit.eviReferenceForm) {
        this.createForm(this.evidenceFormEdit)
      } else {
        this.createForm()
      }

    }

    if (changes.evidenceList && changes.evidenceList.currentValue) {
      this.evidenceList = changes.evidenceList.currentValue
    }

    // console.log("Leaner Id", this.learnerId, "jobId", this.jobId)
  }



  //create Form

  createForm(details?) {
    console.log("HELLO EVIDENCE DETAILS===>", details)
    this.eviReferenceForm = new FormGroup({
      eviref1: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref1 : ''),
      eviref2: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref2 : ''),
      eviref3: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref3 : ''),
      eviref4: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref4 : ''),
      eviref5: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref5 : ''),
      eviref6: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref6 : ''),
      eviref7: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref7 : ''),
      eviref8: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref8 : ''),
      eviref9: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref9 : ''),
      eviref10: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref10 : ''),
      eviref11: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref11 : ''),
      eviref12: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref12 : ''),
      eviref13: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref13 : ''),
      eviref14: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref14 : ''),
      eviref15: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref15 : ''),
      eviref16: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref16 : ''),
      eviref17: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref17 : ''),
      eviref18: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref18 : ''),
      eviref19: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref19 : ''),
      eviref20: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref20 : ''),
      eviref21: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref21 : ''),
      eviref22: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref22 : ''),
      eviref23: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref23 : ''),
      eviref24: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref24 : ''),
      eviref25: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref25 : ''),
      eviref26: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref26 : ''),
      eviref27: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref27 : ''),
      eviref28: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref28 : ''),
      eviref29: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref29 : ''),
      eviref30: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref30 : ''),
      eviref31: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref31 : ''),
      eviref32: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref32 : ''),
      eviref33: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref33 : ''),
      eviref34: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref34 : ''),
      eviref35: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref35 : ''),
      eviref36: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref36 : ''),
      eviref37: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref37 : ''),
      eviref38: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref38 : ''),
      eviref39: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref39 : ''),
      eviref40: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref40 : ''),
      eviref41: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref41 : ''),
      eviref42: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref42 : ''),
      eviref43: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref43 : ''),
      eviref44: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref44 : ''),
      eviref45: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref45 : ''),
      eviref46: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref46 : ''),
      eviref47: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref47 : ''),

      // eviref44:new FormControl(''),
      selectedCriteria1: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria1 : ''),
      selectedCriteria2: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria2 : ''),
      selectedCriteria3: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria3 : ''),
      selectedCriteria4: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria4 : ''),
      selectedCriteria5: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria5 : ''),
      selectedCriteria6: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria6 : ''),
      selectedCriteria7: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria7 : ''),
      selectedCriteria8: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria8 : ''),
      selectedCriteria9: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria9 : ''),
      selectedCriteria10: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria10 : ''),
      selectedCriteria11: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria11 : ''),
      selectedCriteria12: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria12 : ''),
      selectedCriteria13: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria13 : ''),
      selectedCriteria14: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria14 : ''),
      selectedCriteria15: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria15 : ''),
      selectedCriteria16: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria16 : ''),
      selectedCriteria17: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria17 : ''),
      selectedCriteria18: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria18 : ''),
      selectedCriteria19: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria19 : ''),
      selectedCriteria20: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria20 : ''),
      selectedCriteria21: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria21 : ''),
      selectedCriteria22: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria22 : ''),
      selectedCriteria23: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria23 : ''),
      selectedCriteria24: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria24 : ''),
      selectedCriteria25: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria25 : ''),
      selectedCriteria26: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria26 : ''),
      selectedCriteria27: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria27 : ''),
      selectedCriteria28: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria28 : ''),
      selectedCriteria29: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria29 : ''),
      selectedCriteria30: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria30 : ''),
      selectedCriteria31: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria31 : ''),
      selectedCriteria32: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria32 : ''),
      selectedCriteria33: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria33 : ''),
      selectedCriteria34: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria34 : ''),
      selectedCriteria35: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria35 : ''),
      selectedCriteria36: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria36 : ''),
      selectedCriteria37: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria37 : ''),
      selectedCriteria38: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria38 : ''),
      selectedCriteria39: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria39 : ''),
      selectedCriteria40: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria40 : ''),
      selectedCriteria41: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria41 : ''),
      selectedCriteria42: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria42 : ''),
      selectedCriteria43: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria43 : ''),
      selectedCriteria44: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria44 : ''),
      selectedCriteria45: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria45 : ''),
      selectedCriteria46: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria46 : ''),
      selectedCriteria47: new FormControl((details && details.eviReferenceForm) ? details.eviReferenceForm.selectedCriteria47 : ''),

      feedback1: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref1 : '')),
      feedback2: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref2 : '')),
      feedback3: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref3 : '')),
      feedback4: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref4 : '')),
      feedback5: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref5 : '')),
      feedback6: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref6 : '')),
      feedback7: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref7 : '')),
      feedback8: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref8 : '')),
      feedback9: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref9 : '')),
      feedback10: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref10 : '')),
      feedback11: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref11 : '')),
      feedback12: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref12 : '')),
      feedback13: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref13 : '')),
      feedback14: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref14 : '')),
      feedback15: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref15 : '')),
      feedback16: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref16 : '')),
      feedback17: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref17 : '')),
      feedback18: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref18 : '')),
      feedback19: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref19 : '')),
      feedback20: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref20 : '')),
      feedback21: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref21 : '')),
      feedback22: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref22 : '')),
      feedback23: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref23 : '')),
      feedback24: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref24 : '')),
      feedback25: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref25 : '')),
      feedback26: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref26 : '')),
      feedback27: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref27 : '')),
      feedback28: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref28 : '')),
      feedback29: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref29 : '')),
      feedback30: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref30 : '')),
      feedback31: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref31 : '')),
      feedback32: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref32 : '')),
      feedback33: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref33 : '')),
      feedback34: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref34 : '')),
      feedback35: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref35 : '')),
      feedback36: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref36 : '')),
      feedback37: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref37 : '')),
      feedback38: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref38 : '')),
      feedback39: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref39 : '')),
      feedback40: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref40 : '')),
      feedback41: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref41 : '')),
      feedback42: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref42 : '')),
      feedback43: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref43 : '')),
      feedback44: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref44 : '')),
      feedback45: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref45 : '')),
      feedback46: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref46 : '')),
      feedback47: new FormControl(this.displayFeedback((details && details.eviReferenceForm) ? details.eviReferenceForm.eviref47 : '')),

    })

    // if (this.isLearner)
    //   this.eviReferenceForm.controls['feedback1'].disable();

  }

  // UTILITIY Function

  selectedCriteriaType(event, controlName) {


    console.log("Selected changes..", event.value)

    let tempfeed = []
    let data = event.value
    let tempEvidence = this.evidenceList
    let result = tempEvidence.filter(o1 => data.some(o2 => o1._id === o2));
    let arrayLength = result.length;

    for (let i = 0; i < arrayLength; i++) {

      if (result[i] && result[i].feedback) {
        tempfeed.push(result[i].feedback)

      }
    }

    tempfeed.join()
    this.eviReferenceForm.get(controlName).setValue(tempfeed)
    this.evidenceFormEdit.eviReferenceForm = this.eviReferenceForm.value

  }


  compareObjects(o1: any, o2: any): boolean {
    console.log("compareObjects called")
    return o1._id === o2._id;
  }

  criteriaBackGround(value) {
    // console.log("value For Color", value)
    if (value == 'Not Met') {
      return 'red'
    } else if (value == 'Part Met') {
      return 'orange'
    }
    else if (value == 'Met') {
      return 'green'
    }
    else {
      return 'normal'
    }
  }

  displayFeedback(data?) {
    // console.log("evidence ARRAY==>", data)



    if (data && data.length) {

      let tempEvidence = this.evidenceList
      let result = tempEvidence.filter(o1 => data.some(o2 => o1._id === o2));
      console.log("Hello Here is the feedback==>", result)

      let tempfeed = []
      let arrayLength = result.length;
      for (let i = 0; i < arrayLength; i++) {

        if (result[i] && result[i].feedback) {
          tempfeed.push(result[i].feedback)
        }
      }

      tempfeed.join()
      return tempfeed

    }

  }


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }



  //API CALL


  // getEvidenceList() {
  //   console.log("evidence Refernce Here ...CAll");

  //   this._learnerService.getEvidenceByLearner(this.learnerId, this.jobId).subscribe(res => {
  //     console.log("evidence Refernce Here ...", res);
  //     if (res && res.length) {

  //       // this.evidenceList = res
  //       let tempEvi = []
  //       var arrayLength = res.length;
  //       for (var i = 0; i < arrayLength; i++) {
  //         // console.log(res[i]);
  //         let data = {
  //           _id: (res[i]._id) ? res[i]._id : '',
  //           title: (res[i].title) ? res[i].title : '',
  //           evidenceNo: (res[i].evidenceNo) ? res[i].evidenceNo : '',
  //           feedback: (res[i].feedback) ? res[i].feedback : ''

  //         }
  //         tempEvi.push(data)
  //       }

  //       this.evidenceList = tempEvi
  //       this.createForm(this.evidenceFormEdit)

  //     }
  //   }, (error) => {
  //     console.log("Soeme error occure when Get EVi List", error)
  //   })
  // }



  submitEvirefernce() {
    // this.evireference
    console.log("HELLO EVidence REFFFFF...", this.eviReferenceForm.value)
    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId,
      details: {
        eviReferenceForm: this.eviReferenceForm.value
      }
    }

    console.log("EDit Evidence Object Replace", this.evidenceFormEdit.eviReferenceForm)
    // this.evidenceFormEdit['details'].eviReferenceForm=this.eviReferenceForm.value
    this.loading = true
    console.log("eviiiii==>", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.evidenceFormEdit.eviReferenceForm = this.eviReferenceForm.value
      if (!this.isDisplay) this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
      this.isDisplay = false
    }, (err) => {
      this.loading = false
      console.log("form not accepted", err)
    })
  }


  downloadEviRef() {
    // let data = this.eviReferenceForm.value
    let data = {
      learner: this.currentLearner,
      jobId: this.jobId,
      formName: 'eviReferenceForm'
    }

    this.loading = true
    console.log("data pass for pdf", data);

    this._learnerService.evidenceRefPdf(data).subscribe((res) => {
      this.loading = false
      console.log("HELLO HERE IS RESPONSE:::", res.data)
      let byteArray = new Uint8Array(res.data);
      console.log("======byteArray =======", byteArray)
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      console.log("blobblobblobblobblob", blob)
      let title = this.job.title + '-' + this.currentLearner.name.split(' ').join('_') + ' - Criteria' + '.pdf'
      saveAs(blob, title);
      //  this.isSpinner = false
    }, (error) => {
      console.log("pdf Genarate Some error", error)
      this.loading = false

    })

  }

}
